import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';

import { Icon } from './Icon';
import styles from './EmptyState.module.scss';

type EmptyStateProps = {
  readonly icon?: ReactNode;
  readonly title?: string;
  readonly description?: string;
};

export function EmptyState({
  icon = <Icon name="inbox" size={48} />,
  title,
  description,
}: EmptyStateProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <span className={styles.icon}>{icon}</span>
      <h3 className={styles.title}>{title ?? t('common.emptyTitle')}</h3>
      <p className={styles.description}>{description ?? t('common.emptyDescription')}</p>
    </div>
  );
}
